import { CopyIcon } from "assets/svg";
import styled from "styled-components";

import { TooltipContainer } from "uikit/Tooltip/styles";

export const Container = styled.span`
  display: inline-block;
`;

export const StyledTooltipContainer = styled(TooltipContainer)`
  display: inline-block;
  cursor: pointer;

  .__react_component_tooltip {
    width: auto;
    min-width: 70px;
    text-align: center;

    &:before {
      display: none;
    }
  }
`;

export const ContainerInner = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const CopyButtonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const StyledCopyIcon = styled(CopyIcon)`
  path {
    stroke: ${({ theme }) => theme.colors.colorsNew.gray["500_main"]};
  }
`;
